export default "__VITE_ASSET__vi_DYTDu__"